export default "__VITE_ASSET__Cb2L0bUa__"